import request from '@/router/axios'

export function fetchAppeals(query) {
  return request({
    url: '/post/admin/post-appeals/page',
    method: 'GET',
    params: query
  });
}

export function acceptAppeal(data) {
  return request({
    url: '/post/admin/post-appeals/up-post',
    method: 'PUT',
    data
  });
}

export function rejectAppeal(data) {
  return request({
    url: '/post/admin/post-appeals/reject',
    method: 'PUT',
    data
  });
}

export function pendingAppeal(data) {
  return request({
    url: '/post/admin/post-appeals/pending',
    method: 'PUT',
    data
  });
}
